import React from 'react';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/joy';
import { Link } from 'react-router-dom';
import { useProfile } from '../hooks/useProfile';
import CISView from './CISView';
import MyCisCertificates from './MyCisCertificates';

/**
 * Finance → CIS Certificates. Fitters and labourers get their own statements only; office staff
 * see every subcontractor's CIS by tax month.
 */
const CisCertificatesPage: React.FC = () => {
  const { loading, isSiteCrew } = useProfile();

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;
  }
  if (isSiteCrew) return <MyCisCertificates />;

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1280 }}>
      <Stack spacing={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={1}>
          <Stack spacing={0.5}>
            <Typography level="h3">CIS Certificates</Typography>
            <Typography level="body-sm" textColor="neutral.600" sx={{ maxWidth: 760 }}>
              CIS deducted from subcontractor bills, by HMRC tax month (6th to 5th). Paid bills count in the month they were paid, others in their invoice month. Keystone subcontractors see their own certificates once each month has ended.
            </Typography>
          </Stack>
          <Box>
            <Button variant="outlined" color="neutral" component={Link} to="/bills?subcontractors=1">Bills</Button>
          </Box>
        </Stack>
        <CISView />
      </Stack>
    </Box>
  );
};

export default CisCertificatesPage;
